import { render, staticRenderFns } from "./TemplateLinkCompaniesDialog.vue?vue&type=template&id=15d29980&scoped=true"
import script from "./TemplateLinkCompaniesDialog.vue?vue&type=script&lang=js"
export * from "./TemplateLinkCompaniesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d29980",
  null
  
)

export default component.exports